export default __webpack_public_path__ + "static/media/002-facebook.f91c950e.svg";